import { Button, Col, Modal, Row, Space, Form, Input, Select, Switch, FormInstance, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import EAttributeForm from "../../../components/eattributeform/EAttributeForm";
import { LineOutlined } from '@ant-design/icons';
import URL from "../../../server/URL";
import Server from "../../../server/Server";
import EAttribute from "../../../utils/EAttribute";
import ComparisonProductPrice from "./ComparisonProductPrice";

interface IComparisonProductEdit {
    viewMode: number,
    comparisonProductID: string | null,
    comparisonProductName: string | null,
    reLoad: () => void
}

const ComparisonProductEdit = forwardRef((props: IComparisonProductEdit, ref: any) => {
    const { viewMode, comparisonProductID, comparisonProductName, reLoad } = props;
    const [visible, setVisible] = useState(false);

    const [attributeData, setAttributeData] = useState<any>([]);
    const [showAttribute, setShowAttribute] = useState(false);
    const [priceData, setPriceData] = useState<any[]>([]);

    const [companyData, setCompanyData] = useState<any>([]);
    const formRef = useRef<FormInstance>(null);
    const refComparisonProductPrice = useRef<any>(null);

    useImperativeHandle(ref, () => ({
        setVisible: setVisible,
    }));

    useEffect(() => {
        if (visible) {
            loadAttribute();
            loadCompany();
            switch (viewMode) {
                case 0:
                    setData(null);
                    break;
                case 1:
                    getComparisonProduct();
                    break;
                case 2:
                    getComparisonProduct();
                    break;
            }
        }
    }, [visible])

    const loadAttribute = () => {
        var request = {
            typeEnum: 0
        }
        Server.Post(URL.AttributeRule.GetAttributeRuleDetailByType, request, false).then((response: any) => {
            if (response.isSuccess) {
                setAttributeData(response.data);
                if (response.data?.filter((i: any) => i.isActive).length > 0) {
                    setShowAttribute(true);
                }
            }
        })
    }

    const loadCompany = () => {
        Server.Post(URL.Company.GetCompanyOptions, {}, false).then((response: any) => {
            if (response.isSuccess) {
                setCompanyData(response.data);
            }
        })
    }

    const setData = (record: any) => {
        formRef.current?.resetFields();
        if (record) {
            formRef.current?.setFieldsValue({
                ...record,
                company: { value: record.companyID, label: record.companyName }
            });
        }
        else {
            setPriceData([]);
        }
    }

    const getComparisonProduct = () => {
        if (comparisonProductID) {
            var params = {
                comparisonProductID: comparisonProductID
            };
            Server.Post(URL.ComparisonProduct.GetComparisonProduct, params, false).then((response: any) => {
                if (response.isSuccess) {
                    setData(response);
                    setPriceData(response.comparisonProductPrices ?? []);
                }
            })
        }
    }

    const onSave = () => {
        formRef.current?.validateFields().then((values => {
            var prices = refComparisonProductPrice?.current.getData() ?? (priceData ?? []);
            var params = {
                comparisonProductID: comparisonProductID,
                ...values,
                companyID: values.company.value,
                companyName: values.company.label,
                comparisonProductPrices: prices
            };

            Server.Post(URL.ComparisonProduct.SaveComparisonProduct, params).then((response: any) => {
                if (response.isSuccess) {
                    message.success('保存成功');
                    setVisible(false);
                    reLoad();
                } else {
                    message.warn(response.returnMsg);
                }
            })
        })).catch((info: any) => {
            if (info && info.errorFields && info.errorFields.length > 0) {
                formRef.current?.scrollToField(info.errorFields[0].name);
            }
            console.log(info);
        });

    }

    const onClose = () => {
        setVisible(false);
    }

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return <Modal width={960}
        centered visible={visible} title={'比价产品[' + (comparisonProductName ?? 'NULL') + ']'}
        maskClosable={false}
        onCancel={onClose}
        bodyStyle={{ padding: '0px' }}
        footer={<Space>
            <Button type="primary" onClick={onSave}>保存</Button>
            <Button danger onClick={onClose}>关闭</Button>
        </Space>}>
        <div style={{ maxHeight: '520px', overflow: 'auto', padding: '10px' }}>
            <Form ref={formRef}
                labelCol={{ flex: '105px' }}
                labelWrap
                scrollToFirstError={true}>
                <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />
                    {'基本信息'}
                </div>
                <Row>
                    <Col span={24}>
                        <Form.Item label="产品名称" style={{ marginBottom: '5px' }}
                            name="comparisonProductName"
                            initialValue={null}
                            rules={[{ required: true, message: '请输入产品名称' }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="保险公司" style={{ marginBottom: '5px' }}
                            name="company"
                            initialValue={null}
                            rules={[{ required: true, message: '请选择保险公司' }]}>
                            <Select labelInValue style={{ width: '100%' }}
                                showSearch
                                optionFilterProp="children"
                                filterOption={filterOption}
                                options={companyData} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label='保险险种' name={'insuranceType'}
                            initialValue={'货运险'}
                            rules={[{ required: true, message: '请选择保险险种' }]}>
                            <Select
                                style={{ width: '100%' }}
                                showSearch
                                optionFilterProp="children"
                                filterOption={filterOption}
                                options={[
                                    { value: '货运险', label: '货运险' },
                                    { value: '物流责任险', label: '物流责任险' },
                                    { value: '雇主责任险', label: '雇主责任险' },
                                    { value: '团体意外险', label: '团体意外险' },
                                    { value: '仓储险', label: '仓储险' },
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="禁保区域" style={{ marginBottom: '5px' }}
                            name="insureArea"
                            initialValue={''}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="产品特色" style={{ marginBottom: '25px' }}
                            name="productFeatures"
                            initialValue={''}>
                            <TextArea showCount rows={3} maxLength={4000} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="询价要求" style={{ marginBottom: '25px' }}
                            name="insureRequirements"
                            initialValue={''}>
                            <TextArea showCount rows={3} maxLength={4000} /></Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="保险条款" style={{ marginBottom: '25px' }}
                            name="clauses"
                            initialValue={''}>
                            <TextArea showCount rows={5} maxLength={10000} /></Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="询价时效" style={{ marginBottom: '25px' }}
                            name="insureTimeDesc"
                            initialValue={''}>
                            <TextArea showCount rows={5} maxLength={10000} /></Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="备注" style={{ marginBottom: '25px' }}
                            name="remark"
                            initialValue={''}>
                            <TextArea showCount rows={3} maxLength={2000} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row >
                    <Col span={12}>
                        <Form.Item
                            style={{ marginBottom: '5px' }}
                            label={'临牌超牌'} name={'isTemp'} initialValue={true} valuePropName={'checked'}>
                            <Switch checked />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            style={{ marginBottom: '5px' }}
                            label={'启用'} name={'isActive'} initialValue={true} valuePropName={'checked'}>
                            <Switch checked />
                        </Form.Item>
                    </Col>
                </Row>
                <EAttributeForm title={'产品属性'} viewMode={0} data={attributeData} />
                <ComparisonProductPrice viewMode={viewMode} data={priceData} ref={refComparisonProductPrice} />
            </Form>
        </div>
    </Modal>
});
export default ComparisonProductEdit;